import zhHans from 'vuetify/es5/locale/zh-Hans'

export default {
  ...zhHans,
  fileInput: {
    counter: '{0} 个文件',
    counterSize: '{0} 个文件 (共：{1})'
  }
}
